function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.354 6.565l.211 2.274L5.838 20H4.572l-.75-11.16.187-2.275-2.532.352H0v-2.65h1.477l2.532.375-.187-1.711V0h2.743v2.93l-.211 1.712 2.556-.375h1.453v2.65H8.91l-2.556-.352z",
  fill: "params(fill) #fff"
});

function SvgDagger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDagger;